import {
  Badge,
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  useToast,
} from '@hub-la/shadcn'
import { useTranslation } from 'react-i18next'
import { useDeactivateSubscriptionBatch } from '../../hooks/use-deactivate-subscription-batch'

type Props = {
  subscriptionIds: string[]
  open: boolean
  onClose: () => void
  onSuccess: () => void
}

export const DeactivateSubscriptionBatchModal: React.FC<Props> = (props) => {
  const { subscriptionIds, open, onClose, onSuccess } = props
  const { mutate: deactivateSubscriptionBatch, isLoading } = useDeactivateSubscriptionBatch()
  const { t } = useTranslation()
  const { toast } = useToast()

  const onSubmit = async () => {
    deactivateSubscriptionBatch(
      { subscriptionIds },
      {
        onSuccess: () => {
          onSuccess()
          onClose()
          toast({
            description: t('success') ?? '',
          })
        },
        onError: (error) => {
          toast({
            description: t((error as Error)?.message) ?? '',
            variant: 'destructive',
          })
        },
      },
    )
  }

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Cancelar assinatura</DialogTitle>
          <DialogDescription>
            Ao cancelar as assinaturas, a renovação automática será desativada. Os membros manterão o acesso à
            assinatura até o final do período já pago, e a assinatura será encerrada na data de vencimento.
          </DialogDescription>
          <div className="pt-4">
            {subscriptionIds.length > 1 && <Badge>{`${subscriptionIds.length} assinantes selecionados`}</Badge>}
          </div>
        </DialogHeader>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onClose}>
            Voltar
          </Button>
          <Button loading={isLoading} variant="destructive" onClick={onSubmit} disabled={isLoading}>
            Cancelar assinatura(s)
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
